import { cn } from 'src/lib/utils'

export function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      role="status"
      aria-label="Loading"
      viewBox="0 0 24 24"
      className={cn('size-4 animate-spin', className)}
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="9.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="45 15"
        transform="rotate(-45 12 12)"
      />
    </svg>
  )
}
